import { z } from 'zod';

export const MDMGeolocationPositionsSchema = z.object({
  address: z.string(),
  date: z.date(),
  latitude: z.number(),
  longitude: z.number(),
  timestamp: z.number(),
});

export const MDMStatusItemSchema = z.union([
  z.any(),
  z.array(MDMGeolocationPositionsSchema),
]);

/**
 * MDMStatus is a key-value pair of status items, with no specific requirements on the keys.
 */
export const MDMStatusSchema = z.record(
  z.string(),
  MDMStatusItemSchema.optional(),
);

export const MDMStatusResponseSchema = MDMStatusSchema;

export const MDMRebootDeviceResponseSchema = z.object({
  isSuccessful: z.boolean(),
});

export type MDMGeolocationPositions = z.infer<
  typeof MDMGeolocationPositionsSchema
>;
export type MDMRebootDeviceResponse = z.infer<
  typeof MDMRebootDeviceResponseSchema
>;
export type MDMStatusItem = z.infer<typeof MDMStatusItemSchema>;
export type MDMStatus = z.infer<typeof MDMStatusSchema>;
export type MDMStatusResponse = MDMStatus;
